import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import {
	Filters,
	fnCallable,
	GetMatterCSVExportRequest,
	GetMatterListRequest,
} from '@fnModels/matter-list';
import { Matter } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AuthState } from '@state/auth';
import { AuthUser } from '@state/auth/auth.models';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MatterFilterFunctions {
	@SelectSnapshot(AuthState.getLoggedInUser) authUser: AuthUser;

	constructor(private fns: AngularFireFunctions) {}

	getMatterList = (filters: Filters): Observable<Matter[]> => {
		const callable = this.fns.httpsCallable(fnCallable.getMatterList);

		const request: GetMatterListRequest = {
			filters,
		};

		return callable(request);
	};

	getMatterCSV = (filters: Filters): Observable<unknown> => {
		const callable = this.fns.httpsCallable(fnCallable.getMatterCSVExport);

		const request: GetMatterCSVExportRequest = {
			filters,
		};

		return callable(request);
	};
}
